/**
 * hamburgers - burger menu - animation
 */
const burgerButton = document.getElementById('burger-menu-btn')

if (burgerButton != null) {
    burgerButton.addEventListener('click', function () {
        burgerButton.classList.toggle('is-active')
    })
}

